import { createReducer, createNamespacer } from '../commons/js/utils/reducer';
import { combineReducers } from "redux";

const initialState = {
    list: {
        isLoading: false,
        bomVersions: [],
        packageName: '',
    },
}

const namespacers = {
    listFiles: createNamespacer("BOM_VERSIONS_LIST"),
}

const listReducer = createReducer(initialState.list, {
    [namespacers.listFiles("SET_BOM_VERSIONS")]:(state, action) => {
        return {
            ...state,
            bomVersions: action.payload.value,
            packageName: action.payload.packageName,
        }
    },
    [namespacers.listFiles("SET_LOADING")]:(state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
});

const reducer = combineReducers({
    list: listReducer,
})

export default reducer;
